module.exports = __webpack_public_path__ + "img/prop-trading-step-banner-mid.6e92aba7.png";